module.exports = __webpack_public_path__ + "img/SE5164061029.1ef08040.svg";